import ky from "ky";
import { API_BASE } from "./env";

export const http = ky.create({
  prefixUrl: API_BASE || undefined,
  headers: { "X-Client": "claimsupp-old-app" },
});
